<template>
    <div class="com-setting member-tab">
        <new-policy class="com-setting-div" :type="1" mainTitle="自訂合約條款 ( 電子合約內容 )"></new-policy>
        <!-- <new-policy class="com-setting-div" :type="2" mainTitle="押金退款政策"></new-policy> -->
    </div>
</template>
<script>
import NewPolicy from '@/components/widge/NewPolicy.vue';

export default {
    components: {
        NewPolicy
    }
}
</script>
<style lang="scss" scoped>
    .com-setting{
        .com-setting-div{
            padding: 30px;
        }
        min-height: 554px;
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/ComSetting.vue